export const latin_num = {
  validate: value => new RegExp(/^([a-zA-Z0-9]+)$/).test(value)
};
